/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Manual_Fix_LabelInputs */



/**
* | output |
* | --- |
* | "Manual" |
*
* @param {Qc_Manual_Fix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_manual_fix_label = /** @type {((inputs?: Qc_Manual_Fix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Manual_Fix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuell")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вручную")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("手动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनुअल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manual")
	return /** @type {LocalizedString} */ ("Manual")
});